import React, {Fragment, useState, useEffect} from 'react'
import {Button, Row} from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import UserService from '../../../../../services/user'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../../utils/helpers/FormGenerator'
import MasterServices from '../../../../../services/master'

type Props = {
  onChange?: (e: any) => void
  toggle: () => void
  getData: any
  editFormValue?: any
  loading: boolean
}

const FormAddressDomicile: React.FC<Props> = ({toggle, getData, editFormValue, loading}) => {
  const [submit, setSubmit] = useState(false)
  const [formValue, setFormValue] = useState<any>({
    country_name: null,
    province_name: null,
    city_name: null,
    district_name: null,
    village_id: null,
    postal_code: null,
    is_domicile: 1,
    user_address: null,
    id: null,
  })
  const [inputs, setInputs] = useState<any>([
    {
      name: 'user_address',
      label: 'Alamat Lengkap',
      type: 'textarea',
      validation: {},
      col: 12,
      options: [],
      additional: '',
    },
    {
      name: 'village_id',
      label: 'Desa/Kecamatan',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'villages_name',
      getItemValueId: 'villages_id',
    },
    {
      name: 'postal_code',
      label: 'Kode Pos',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'country_name',
      label: 'Negara',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      disabled: true,
    },
    {
      name: 'province_name',
      label: 'Provinsi',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      disabled: true,
    },
    {
      name: 'city_name',
      label: 'Kota',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      disabled: true,
    },
    {
      name: 'district_name',
      label: 'Kabupaten',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      disabled: true,
    },
  ])
  const [villages, setVillages] = useState([])

  useEffect(() => {
    let domicileAddress = getDomicileAddress(editFormValue?.addresses)[0] ?? null
    setFormValue({
      ...formValue,
      country_name: domicileAddress?.province?.country?.countries_name,
      province_name: domicileAddress?.province?.provinces_name,
      city_name: domicileAddress?.city?.cities_name,
      district_name: domicileAddress?.district?.districts_name,
      village_id: domicileAddress?.village,
      postal_code: domicileAddress?.user_addresses_postal_code,
      user_address: domicileAddress?.user_addresses,
      id: domicileAddress?.user_addresses_id,
    })
  }, [editFormValue])

  useEffect(() => {
    fetchVillage()
  }, [])

  useEffect(() => {
    let newVillages = villages.map((item: any) => {
      item.villages_name = `${item?.villages_name} - ${item?.district?.districts_name} - ${item?.district?.city?.cities_name}`
      return item
    })

    inputs[1].options = newVillages
    
    setInputs(inputs)
  }, [villages])

  const getDomicileAddress = (addresses: any) => {
    return addresses.map((item: any) => {
      if (item.user_addresses_is_domicile == 1) {
        return item
      }
    })
  }

  const onKeyUp = (input: any, value: any) => {
    switch (input) {
      case 'village_id':
        fetchVillage(value)
        break
    }
  }

  const fetchVillage = (q = '') => {
    MasterServices.getVillage({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        setVillages(data)
      })
      .catch((err) => {
      })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    if (name == 'village_id') {
      setFormValue({
        ...formValue,
        village_id: value,
        district_name: value?.district?.districts_name,
        city_name: value?.district?.city?.cities_name,
        province_name: value?.district?.city?.province?.provinces_name,
        country_name: value?.district?.city?.province?.country?.countries_name,
      })
      return
    }

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleSubmit = async (e: any) => {
    try {
      e?.preventDefault()
      let data = formValue
      data.village_id = formValue?.village_id?.villages_id

      setSubmit(true)

      await UserService.createOrUpdateAddress(data, formValue.id).then(() => {
        toast.success(`Data Berhasil ${formValue.id ? 'Diperbarui' : 'Dibuat'}`)
        toggle()
        getData()
      })
    } catch (error) {
    } finally {
      setSubmit(false)
    }
  }

  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <Row>{FormGenerator(inputs, formValue, onChange, onKeyUp)}</Row>
        <Modal.Footer>
          <Button className='btn btn-secondary btn-sm' onClick={toggle} disabled={submit}>
            Batalkan
          </Button>
          <Button className='btn btn-primary btn-sm' type='submit' disabled={submit}>
            {submit ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </Form>
    </Fragment>
  )
}

export default FormAddressDomicile
